import { createAction } from '@reduxjs/toolkit';

import { SET_PRICES, type Prices } from './types';

export const setPrices = createAction<Prices, typeof SET_PRICES>(SET_PRICES);
